const getDate = (dt: string) => {
  const date = new Date(dt)
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${day}-${month}-${year}`
}

export default getDate
